module.exports = __webpack_public_path__ + "static/img/ibp.d8dd74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ibp.png
// module id = IYOK
// module chunks = 1